import { textChooser } from "../../common/util/textChooser";
import "./help.style.scss";

export const Help = () => {

    return(
        <div className="page -help">
            <h1 className="page-title">{textChooser("txt56")}</h1>
        </div>
    )
}